import React from "react";
import Jibber from "/app/src/jibber";
import TextareaAutosize from "react-autosize-textarea";
import {
  SVGButton,
  Flex,
  MarkdownEditor,
  MarkdownDisplay,
} from "/app/src/component";

import style from "./style.css";

class Item extends Jibber {
  constructor(props) {
    super(props);

    this.useState({
      hover: false,
      title: props.title,
      body: props.body,
      confirmRemoval: false,
      screen: "normal",
    });

    this._renderNormalState = this._renderNormalState.bind(this);
    this._renderEditorState = this._renderEditorState.bind(this);
    this._renderConfirmRemoval = this._renderConfirmRemoval.bind(this);

    this._changeView = this._changeView.bind(this);
    this._confirmRemoval = this._confirmRemoval.bind(this);
    this._onClick = this._onClick.bind(this);

    this._save = this._save.bind(this);
    this._remove = this._remove.bind(this);
  }

  _changeView() {
    if (this.state.screen === "normal") {
      this.setScreen("edit");
    } else {
      this.setScreen("normal");
    }
  }

  _save(e, id, title, body) {
    this.props.saveToDatabase(e, id, title, body);
    this.setScreen("normal");
  }

  _remove(e, id) {
    this.props.removeFromDatabase(e, id);
    this.setScreen("normal");
  }

  _confirmRemoval(confirm) {
    this.setState({ confirmRemoval: confirm });
  }

  _onClick() {
    this.props._onClick();
  }
  _renderConfirmRemoval() {
    return (
      <Flex position="absolute" w="100%" h="100%" z="1" center>
        <Flex
          w="80%"
          h="87px"
          borderRadius="20px"
          border="3px solid"
          color="grey"
          column
          center
          paddingTop="10px"
          backgroundColor="white"
        >
          <Flex>
            Radera &nbsp; <strong> {this.props.title.substring(0, 30)}</strong>?
          </Flex>
          <Flex
            className={style.PopupBody}
            grow
            width="100%"
            hAlignContent="center"
            vAlignContent="center"
          >
            <SVGButton
              src="/images/Return.svg"
              text="Tillbaka"
              border
              color="darkgrey"
              hover="blue"
              height="30px"
              onClick={() => this._confirmRemoval(false)}
            />
            <Flex width="20px" />
            <SVGButton
              border
              onClick={(e) => this._remove(e, this.props.id)}
              src="/images/Trash.svg"
              text="Ta bort"
              color="darkgrey"
              hover="red"
              height="30px"
            />
          </Flex>
        </Flex>
      </Flex>
    );
  }
  _renderNormalState() {
    let answer, question;
    let focused = this.props.id === this.props.currentItem;
    let hover = this.state.hover;
    if (this.props.isEdit) {
      focused = false;
      hover = false;
    }
    if (focused) {
      question = this.props.title;
    } else {
      question = <div className="ellipsis">{this.props.title}</div>;
    }

    answer = <MarkdownDisplay text={this.props.body} />;

    const PreviewFAQ = (
      <Flex column basis="75%" borderRadius="60px">
        <Flex column grow>
          <Flex className={style.ItemTitle}>{question}</Flex>
          <Flex className={style.ItemBody} grow>
            {answer}
          </Flex>
        </Flex>
      </Flex>
    );

    const OptionFields = (
      <Flex hAlignContent="right" basis="25%">
        <Flex h="90px">
          {hover || focused ? (
            <React.Fragment>
              <SVGButton
                src="/images/Edit_M.svg"
                color="lightblack"
                marginLeft="3px"
                hover="blue"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props._onClick();
                  this.setState({ screen: "edit" });
                }}
              />
              <SVGButton
                size="medium"
                color="lightblack"
                hover="red"
                src="/images/Trash.svg"
                onClick={() => this._confirmRemoval(true)}
              />

              <SVGButton
                color="lightblack"
                hover="blue"
                onClick={() =>
                  this.props.updateItem(this.props.item.id, {
                    visible: !this.props.item.visible,
                  })
                }
                src={
                  this.props.item.visible
                    ? "/images/Visible.svg"
                    : "/images/Hidden.svg"
                }
              />
            </React.Fragment>
          ) : (
            <SVGButton
              color="lightblack"
              hover="blue"
              onClick={() =>
                this.props.updateItem(this.props.item.id, {
                  visible: !this.props.item.visible,
                })
              }
              src={
                this.props.item.visible
                  ? "/images/Visible.svg"
                  : "/images/Hidden.svg"
              }
            />
          )}
        </Flex>
      </Flex>
    );

    const DragnDrop = (
      <Flex
        w="100%"
        h="100%"
        position="absolute"
        center
        backgroundImage="linear-gradient(to left, rgba(255, 255, 255, 0), #f0f0f0 49%, rgba(255, 255, 255, 0))"
      >
        <SVGButton src="/images/DragnDrop.svg" color="darkgrey" />
      </Flex>
    );

    return (
      <Flex
        height={focused ? "auto" : "95px"}
        className={style.ListItem}
        color="lightgrey"
        paddingRight="10px"
        basis="200px"
        grow
        overflow="hidden"
        border={focused ? "3px solid #2ea2d2" : "3px solid transparent"}
        backgroundColor={focused ? "lightblue" : "darkwhite"}
        backgroundHover={focused ? "" : "mediumgrey"}
        onMouseEnter={() => this.setHover(true)}
        onMouseLeave={() => this.setHover(false)}
        onClick={() => this._onClick()}
      >
        {this.props.isEdit && DragnDrop}
        {this.state.confirmRemoval && this._renderConfirmRemoval()}
        {PreviewFAQ}
        {OptionFields}
      </Flex>
    );
  }
  _renderEditorState() {
    let focused = this.props.id === this.props.currentItem;
    return (
      <Flex
        width="100%"
        className={style.FAQItem}
        borderRadius="60px"
        border={focused ? "3px solid #2ea2d2" : "3px solid transparent"}
        padding="10px"
      >
        <Flex column grow height="100%" padding="10px 0 10px 34px" mb="40px">
          <Flex column grow>
            <Flex className={style.FAQItemQuestionTextArea}>
              <TextareaAutosize
                value={this.state.title}
                onChange={(e) => {
                  this.setTitle(e.target.value);
                }}
              />
            </Flex>
            <Flex className={style.FAQItemAnswerTextArea} grow>
              <MarkdownEditor
                height="200px"
                text={this.state.body}
                onTextChange={(text) => {
                  this.setBody(text);
                }}
              />
            </Flex>
          </Flex>
        </Flex>

        <Flex hAlignContent="center" basis="15%">
          <Flex
            className={style.FAQItemOptions}
            column
            vAlignContent="center"
            hAlignContent="center"
          >
            <Flex mb="20px" mt="10px">
              <SVGButton
                onClick={(e) =>
                  this._save(
                    e,
                    this.props.id,
                    this.state.title,
                    this.state.body
                  )
                }
                src="/images/Save.svg"
                color="darkgrey"
                hover="blue"
                border
                width="100%"
              />
            </Flex>
            <Flex>
              <SVGButton
                onClick={this._changeView}
                src="/images/Return.svg"
                color="darkgrey"
                hover="blue"
                border
                width="100%"
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
  render() {
    if (this.props.searchInput) {
      let searchInput = this.props.searchInput.toLowerCase();
      if (
        !this.props.title.toLowerCase().includes(searchInput) &&
        !this.props.body.toLowerCase().includes(searchInput)
      ) {
        return null;
      }
    }
    if (this.props.isEdit) {
      return this._renderEditorState();
    }
    switch (this.state.screen) {
      case "edit":
        return this._renderEditorState();
      case "normal":
      default:
        return this._renderNormalState();
    }
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Normal/ListItem/index.js